import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" It looks like there isn't any data for this type of comparison - This could be due to the date period selection or data not being present. Get in touch with us for help on adding data for this type of comparison. ")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", null, "[Admin only]", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" This report hasn't been setup / configured to use the new data source - This can cause the report to run slower than others. Get in touch with tech to find out whether the data source hasn't been configured or isn't setup for this report. ")
const _hoisted_4 = { class: "contains-loader" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "contains-loader" }
const _hoisted_7 = { class: "columns is-multiline" }
const _hoisted_8 = { class: "column is-full" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-content" }
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  class: "column is-full"
}
const _hoisted_13 = { class: "card" }
const _hoisted_14 = { class: "card-content" }
const _hoisted_15 = { class: "content has-text-grey has-text-centered" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "There's no data to show", -1)
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { class: "card-header" }
const _hoisted_19 = { class: "card-header-title" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Explore", -1)
const _hoisted_21 = { class: "card-content" }
const _hoisted_22 = { class: "card-footer" }
const _hoisted_23 = { class: "card-footer-item" }
const _hoisted_24 = { class: "content" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "card-header-title" }, "Current Period", -1)
const _hoisted_26 = { class: "card-footer-item" }
const _hoisted_27 = { class: "content" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "card-header-title" }, "Previous Period", -1)
const _hoisted_29 = { class: "contains-loader" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = { class: "contains-loader" }
const _hoisted_32 = { class: "columns is-multiline" }
const _hoisted_33 = { class: "column is-full" }
const _hoisted_34 = { class: "card" }
const _hoisted_35 = { class: "card-content" }
const _hoisted_36 = { class: "control" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "Columns", -1)
const _hoisted_38 = { class: "modal-card" }
const _hoisted_39 = { class: "modal-card-head" }
const _hoisted_40 = { class: "modal-card-title" }
const _hoisted_41 = { class: "modal-card-body" }
const _hoisted_42 = { class: "modal-card-foot" }
const _hoisted_43 = {
  key: 0,
  class: "column is-full"
}
const _hoisted_44 = { class: "card" }
const _hoisted_45 = { class: "card-content sticky-container" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("th", { class: "is-hidden-mobile" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "" }, "Total")
], -1)
const _hoisted_49 = {
  key: 0,
  class: "text-center"
}
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "section" }
const _hoisted_52 = { class: "content has-text-grey has-text-centered" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", null, "There's no data to show", -1)


import MetaBreadcrumb from "./Breadcrumb.vue";
import MetaChart from "./Chart.vue";
import MetaPie from "./Pie.vue";
import MetaSelect from "./MetaSelect.vue";
import ExportData from "../Pieces/ExportData.vue";
import ColumnSelection from "../Pieces/ColumnSelection.vue";

const __default__ = {
  components: {
    ColumnSelection,
    MetaBreadcrumb,
    MetaSelect,
    MetaChart,
    MetaPie,
    ExportData,
  },
};
import { storeToRefs } from "pinia";
import { UseMainStore } from "../State/SingleViewStorePinia";
import { UseStringHelper } from "../../Helper/Functional/UseStringHelper";
import { UseMetaWritableComputed } from "./Hooks/UseMetaWritableComputed";
import { onMounted, toRefs, ref, watch } from "vue";
import { UseMetaFetchData } from "./Hooks/UseMetaFetchData";
import { UseMetaComparison } from "./Hooks/UseMetaComparison";
import { UseMetaVisualLoadingComputed } from "./Hooks/UseMetaVisualLoadingComputed";
import { UseMetaUrlMethods } from "./Hooks/UseMetaUrlMethods";
import { UseMetaTableMethods } from "./Hooks/UseMetaTableMethods";
import { UseMetaGetterComputed } from "./Hooks/UseMetaGetterComputed";
import { UseMetaDataManipulation } from "./Hooks/UseMetaDataManipulation";
import { UseMetaStaticData } from "./Hooks/UseMetaStaticData";
import { UseMetaExportData } from "./Hooks/UseMetaExportData";
import { UseMetaStatelessFuncs } from "./Hooks/UseMetaStatelessFuncs";
import { UseMetaTableColumns } from "./Hooks/UseMetaTableColumns";
import { IGroupedData } from "./Typings/MetaTypes";
import { useRouter } from "vue-router";
import { UseAxiosErrorHelper } from "../../Helper/ThirdParty/UseAxiosErrorHelper";
import { get, isEmpty } from "lodash";
import { UseDateStore } from "../State/Stores/DateStore";

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    taxonomy: null,
    taxonomyOne: null,
    taxonomyTwo: null,
    taxonomyThree: null,
    taxonomyFour: null,
    meta: null,
    tab: { default: "visual" },
    validName: { default: "Active" },
    cancelledName: { default: "Not Active" }
  },
  setup(__props: any) {

const props = __props as { taxonomy: number, taxonomyOne: string, taxonomyTwo: string, taxonomyThree: string, taxonomyFour: string, meta: {
      cancelledName: string;
      excludedColumns: string[];
      validName: string;
    }, tab: string, validName: string, cancelledName: string }



const { getUserAdmin } = storeToRefs(UseMainStore());
const { getDateFrom, getDateTo } = storeToRefs(UseDateStore());

const { init, comparisonDates, comparisonConfigurationHandler } =
  UseMetaComparison();

//PROPS
const {
  cancelledName,
  validName,
  taxonomy,
  taxonomyOne,
  taxonomyTwo,
  taxonomyThree,
  taxonomyFour,
  meta,
  tab,
} = toRefs(props);

//Creating a computed property from some of the props.
const comparisonConfiguration = comparisonConfigurationHandler(
  cancelledName,
  validName
);

//Handle Tabs
const tabModel = ref(0);
const setTab = () => {
  if (tab.value === "visual") {
    tabModel.value = 0;
  } else {
    tabModel.value = 1;
  }
};

//Set up comparing
const comparing = ref(false);
const isColumnModalActive = ref(false);

//Call in some stateless functions
const { validateInternalParameter } = UseStringHelper();
const { convertNameToHandle } = UseMetaStatelessFuncs();

//Hook stuff

//Get the URLs first before we call any data
const {
  bottomUrl,
  topUrl,
  p1x1Url,
  p1x2Url,
  p2x1Url,
  p2x2Url,
  fetchNavigationUrl,
} = UseMetaUrlMethods({
  taxonomy,
  taxonomyOne,
  taxonomyTwo,
  taxonomyThree,
  taxonomyFour,
  meta,
  comparisonDates,
  comparisonConfiguration,
});
//Get some State data and other useful things that don't need parameters passing to the hook
const {
  chartLoading,
  pieOneLoading,
  pieTwoLoading,
  tableLoading,
  visualLoading,
} = UseMetaVisualLoadingComputed();
const { columns, metaComparison, metaMetric, sortField, sortOrder } =
  UseMetaWritableComputed();

//Hooks where we need to pass some data to.
const { useNewDataSource, availableColumns } = UseMetaGetterComputed({ meta });

const {
  bottomName,
  topName,
  isColumnAvailable,
  isColumnVisible,
  onSort,
  calculateTotalsMetaTable,
} = UseMetaTableMethods({
  meta,
  comparisonConfiguration,
  columns,
  sortField,
  sortOrder,
  metaComparison,
});

const {
  availableMetrics,
  headers,
  headersMetaTabular,
  headersMetaTabularConverted,
  averagedColumns,
} = UseMetaStaticData({ bottomName, topName });

//DATA
const {
  loadAsyncData,
  loadComparisonData,
  loadp1x1,
  loadp1x2,
  loadp2x1,
  loadp2x2,
  data,
  groupedData,
  comparisonData,
} = UseMetaFetchData({
  taxonomy,
  bottomUrl,
  topUrl,
  p1x1Url,
  p1x2Url,
  p2x1Url,
  p2x2Url,
  useNewDataSource,
});

//Manipulate that data
const {
  dataLooksLikeItExists,
  matched,
  tabled,
  allDates,
  overallMin,
  overallMax,
  sortedTabled,
} = UseMetaDataManipulation({
  groupedData,
  data,
  comparisonData,
  taxonomy,
});

//Export that data
const {
  exportColumns,
  exportAlwaysColumns,
  exportColumnsHeaders,
  exportData,
  exportTabularColumns,
  exportSelectedColumns,
  exportTabularHeaders,
  metaTabularExportedData,
} = UseMetaExportData({
  matched,
  tabled,
  bottomName,
  topName,
  taxonomy,
  headersMetaTabular,
  headersMetaTabularConverted,
  columns,
});

//Used in table footer
const findAverageKey = (key: string) => {
  const keyFound = averagedColumns.value.find((col: string) => col === key);
  if (keyFound?.length) {
    return true;
  }
  return false;
};

//Feed the template some data

onMounted(() => {
  init();
  loadAsyncData();
  loadComparisonData();
  loadp1x1();
  loadp1x2();
  loadp2x1();
  loadp2x2();
  setTab();
});
//Watchers
watch(bottomUrl, () => {
  data.value = [];
  groupedData.value = {} as IGroupedData;
  loadAsyncData();
});
watch([topUrl, comparing], () => {
  comparisonData.value = {};
  loadComparisonData();
});
watch(p1x1Url, () => {
  groupedData.value.p1x1 = {} as IGroupedData["p1x1"];
  loadp1x1();
});
watch(p1x2Url, () => {
  groupedData.value.p1x2 = {} as IGroupedData["p1x2"];
  loadp1x2();
});
watch(p2x1Url, () => {
  groupedData.value.p2x1 = {} as IGroupedData["p2x1"];
  loadp2x1();
});
watch(p2x2Url, () => {
  groupedData.value.p2x2 = {} as IGroupedData["p2x2"];
  loadp2x2();
});
watch([comparing, getDateFrom, getDateTo], () => {
  init();
});

//Axios Error Mixin
UseAxiosErrorHelper();

//Remove data so when navigating away from the page the chart doesn't have a hissy fit
const { beforeEach } = useRouter();

beforeEach(() => {
  data.value = [];
});
//Get array of data for table columns
const { footerSkeleton, columnSkeleton } = UseMetaTableColumns();

return (_ctx: any,_cache: any) => {
  const _component_o_notification = _resolveComponent("o-notification")!
  const _component_o_loading = _resolveComponent("o-loading")!
  const _component_o_select = _resolveComponent("o-select")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_o_tab_item = _resolveComponent("o-tab-item")!
  const _component_o_modal = _resolveComponent("o-modal")!
  const _component_o_table_column = _resolveComponent("o-table-column")!
  const _component_performance_field = _resolveComponent("performance-field")!
  const _component_o_table = _resolveComponent("o-table")!
  const _component_o_tabs = _resolveComponent("o-tabs")!
  const _component_outer_section = _resolveComponent("outer-section")!

  return (_openBlock(), _createBlock(_component_outer_section, null, {
    default: _withCtx(() => [
      (!_unref(dataLooksLikeItExists) && !(_unref(tableLoading) || _unref(visualLoading)))
        ? (_openBlock(), _createBlock(_component_o_notification, {
            key: 0,
            type: "is-warning",
            "aria-close-label": "Close notification",
            role: "alert"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_unref(useNewDataSource) && _unref(getUserAdmin))
        ? (_openBlock(), _createBlock(_component_o_notification, {
            key: 1,
            type: "is-warning",
            "aria-close-label": "Close notification",
            role: "alert"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_o_tabs, {
        animated: false,
        modelValue: tabModel.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((tabModel).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_o_tab_item, {
            label: "Visual",
            icon: "chart-scatter-plot-hexbin",
            value: 0
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("section", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          (_unref(isEmpty)(_unref(matched)))
                            ? (_openBlock(), _createBlock(_component_o_loading, {
                                key: 0,
                                "full-page": false,
                                active: _unref(chartLoading) || _unref(pieOneLoading) || _unref(pieTwoLoading)
                              }, null, 8, ["active"]))
                            : _createCommentVNode("", true),
                          _createVNode(MetaBreadcrumb, {
                            "taxonomy-one": _unref(taxonomyOne),
                            "taxonomy-two": _unref(taxonomyTwo),
                            "taxonomy-three": _unref(taxonomyThree)
                          }, null, 8, ["taxonomy-one", "taxonomy-two", "taxonomy-three"]),
                          _createVNode(_component_o_field, {
                            grouped: "",
                            "group-multiline": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_o_field, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_o_select, {
                                    modelValue: _unref(metaMetric),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(metaMetric) ? (metaMetric).value = $event : null))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableMetrics), (option) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          value: option,
                                          key: option
                                        }, _toDisplayString(_unref(headers)[option] || option), 9, _hoisted_11))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_o_field, null, {
                                default: _withCtx(() => [
                                  _createVNode(ExportData, {
                                    "available-columns": _unref(exportColumns),
                                    "selected-columns": _unref(exportColumns),
                                    "always-selected-columns": _unref(exportAlwaysColumns),
                                    "column-headers": _unref(exportColumnsHeaders),
                                    "report-name": 'Data Export',
                                    "exportable-data": _unref(exportData),
                                    "order-data-by": [
                            'taxonomy_' + _unref(taxonomy),
                            'referral_date',
                          ],
                                    "order-data-direction": ['asc', 'asc']
                                  }, null, 8, ["available-columns", "selected-columns", "always-selected-columns", "column-headers", "exportable-data", "order-data-by"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    (_unref(isEmpty)(_unref(matched)) && !_unref(visualLoading))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("p", null, [
                                  _createVNode(_component_o_icon, {
                                    icon: "emoticon-sad",
                                    size: "is-large"
                                  })
                                ]),
                                _hoisted_16
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(matched), (data, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 't1' + index,
                        class: "column is-one-third-desktop is-full-tablet"
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("header", _hoisted_18, [
                            _createElementVNode("p", _hoisted_19, _toDisplayString(index), 1),
                            (_unref(taxonomy) < 4)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: 
                          _unref(fetchNavigationUrl) + _unref(validateInternalParameter)(index)
                        ,
                                  class: "card-header-icon"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_o_icon, {
                                      icon: "chevron-right",
                                      size: "is-small"
                                    }),
                                    _hoisted_20
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_o_loading, {
                              "full-page": false,
                              active: _unref(chartLoading),
                              "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => (_isRef(chartLoading) ? (chartLoading).value = $event : null))
                            }, null, 8, ["active"]),
                            (data && data.data.length)
                              ? (_openBlock(), _createBlock(MetaChart, {
                                  key: 0,
                                  "all-dates": _unref(allDates),
                                  channelData: data.data,
                                  min: _unref(overallMin),
                                  max: _unref(overallMax),
                                  "top-name": 
                          _unref(get)(
                            _unref(comparisonConfiguration),
                            [_unref(metaComparison), 'top', 'name'],
                            ''
                          )
                        ,
                                  "bottom-name": 
                          _unref(get)(
                            _unref(comparisonConfiguration),
                            [_unref(metaComparison), 'bottom', 'name'],
                            ''
                          )
                        
                                }, null, 8, ["all-dates", "channelData", "min", "max", "top-name", "bottom-name"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("footer", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("div", _hoisted_24, [
                                _createVNode(_component_o_loading, {
                                  "full-page": false,
                                  active: _unref(pieOneLoading),
                                  "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => (_isRef(pieOneLoading) ? (pieOneLoading).value = $event : null))
                                }, null, 8, ["active"]),
                                _hoisted_25,
                                (data && data.data.length)
                                  ? (_openBlock(), _createBlock(MetaPie, {
                                      key: 0,
                                      type: "current",
                                      "first-half": 
                              _unref(pieOneLoading)
                                ? {}
                                : _unref(get)(_unref(groupedData), ['p1x1', index], {})
                            ,
                                      "second-half": 
                              _unref(pieOneLoading)
                                ? {}
                                : _unref(get)(_unref(groupedData), ['p1x2', index], {})
                            ,
                                      "top-name": 
                              _unref(get)(
                                _unref(comparisonConfiguration),
                                [_unref(metaComparison), 'top', 'name'],
                                ''
                              )
                            ,
                                      "bottom-name": 
                              _unref(get)(
                                _unref(comparisonConfiguration),
                                [_unref(metaComparison), 'bottom', 'name'],
                                ''
                              )
                            
                                    }, null, 8, ["first-half", "second-half", "top-name", "bottom-name"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createVNode(_component_o_loading, {
                                  "full-page": false,
                                  active: _unref(pieTwoLoading),
                                  "onUpdate:active": _cache[3] || (_cache[3] = ($event: any) => (_isRef(pieTwoLoading) ? (pieTwoLoading).value = $event : null))
                                }, null, 8, ["active"]),
                                _hoisted_28,
                                (data && data.data.length)
                                  ? (_openBlock(), _createBlock(MetaPie, {
                                      key: 0,
                                      type: "previous",
                                      "first-half": 
                              _unref(pieTwoLoading)
                                ? {}
                                : _unref(get)(_unref(groupedData), ['p2x1', index], {})
                            ,
                                      "second-half": 
                              _unref(pieTwoLoading)
                                ? {}
                                : _unref(get)(_unref(groupedData), ['p2x2', index], {})
                            ,
                                      "top-name": 
                              _unref(get)(
                                _unref(comparisonConfiguration),
                                [_unref(metaComparison), 'top', 'name'],
                                ''
                              )
                            ,
                                      "bottom-name": 
                              _unref(get)(
                                _unref(comparisonConfiguration),
                                [_unref(metaComparison), 'bottom', 'name'],
                                ''
                              )
                            
                                    }, null, 8, ["first-half", "second-half", "top-name", "bottom-name"]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_o_tab_item, {
            label: "Tabular",
            icon: "table",
            value: 1
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("section", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(MetaBreadcrumb, {
                            "taxonomy-one": _unref(taxonomyOne),
                            "taxonomy-two": _unref(taxonomyTwo),
                            "taxonomy-three": _unref(taxonomyThree)
                          }, null, 8, ["taxonomy-one", "taxonomy-two", "taxonomy-three"]),
                          _createVNode(_component_o_field, {
                            grouped: "",
                            "group-multiline": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_o_field, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_36, [
                                    _createElementVNode("button", {
                                      class: "button",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (isColumnModalActive.value = true))
                                    }, [
                                      _createVNode(_component_o_icon, { icon: "table-row-height" }),
                                      _hoisted_37
                                    ])
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_o_field, null, {
                                default: _withCtx(() => [
                                  _createVNode(ExportData, {
                                    "available-columns": _unref(exportTabularColumns),
                                    "selected-columns": _unref(exportSelectedColumns),
                                    "always-selected-columns": _unref(exportAlwaysColumns),
                                    "column-headers": _unref(exportTabularHeaders),
                                    "report-name": 'Tabular Data Export',
                                    "exportable-data": _unref(metaTabularExportedData),
                                    "order-data-by": _unref(sortField),
                                    "order-data-direction": _unref(sortOrder)
                                  }, null, 8, ["available-columns", "selected-columns", "always-selected-columns", "column-headers", "exportable-data", "order-data-by", "order-data-direction"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_o_modal, {
                            active: isColumnModalActive.value,
                            "onUpdate:active": _cache[7] || (_cache[7] = ($event: any) => ((isColumnModalActive).value = $event)),
                            "has-modal-card": "",
                            "trap-focus": "",
                            "aria-role": "dialog",
                            "aria-modal": ""
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("header", _hoisted_39, [
                                  _createElementVNode("p", _hoisted_40, " Selected Columns (" + _toDisplayString(_unref(columns).length) + ") ", 1)
                                ]),
                                _createElementVNode("section", _hoisted_41, [
                                  _createVNode(ColumnSelection, {
                                    "available-columns": _unref(availableColumns),
                                    "selected-columns": _unref(columns),
                                    "onUpdate:selected-columns": _cache[5] || (_cache[5] = ($event: any) => (_isRef(columns) ? (columns).value = $event : null)),
                                    "column-headers": _unref(headers)
                                  }, null, 8, ["available-columns", "selected-columns", "column-headers"])
                                ]),
                                _createElementVNode("footer", _hoisted_42, [
                                  _createElementVNode("button", {
                                    class: "button",
                                    type: "button",
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (isColumnModalActive.value = false))
                                  }, " Close ")
                                ])
                              ])
                            ]),
                            _: 1
                          }, 8, ["active"])
                        ])
                      ])
                    ]),
                    (_unref(sortedTabled).length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _createVNode(_component_o_loading, {
                                "full-page": false,
                                active: _unref(tableLoading)
                              }, null, 8, ["active"]),
                              _createVNode(_component_o_table, {
                                class: "has-sticky-table-headers",
                                ref: "metaTableTaxonomyOne",
                                hoverable: "",
                                data: _unref(sortedTabled),
                                "backend-sorting": "",
                                "default-sort-direction": _unref(sortOrder),
                                "default-sort": [_unref(sortField), _unref(sortOrder)],
                                onSort: _unref(onSort)
                              }, _createSlots({
                                empty: _withCtx(() => [
                                  _createElementVNode("section", _hoisted_51, [
                                    _createElementVNode("div", _hoisted_52, [
                                      (!_unref(tableLoading))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("p", null, [
                                              _createVNode(_component_o_icon, {
                                                icon: "emoticon-sad",
                                                size: "is-large"
                                              })
                                            ]),
                                            _hoisted_53
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_o_table_column, {
                                    field: 'data.p1x1.taxonomy_' + _unref(taxonomy),
                                    label: 'Taxonomy ' + _unref(taxonomy),
                                    sortable: "",
                                    style: {"vertical-align":"center"}
                                  }, {
                                    default: _withCtx((props) => [
                                      (_unref(taxonomy) < 3)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                            _createVNode(_component_router_link, {
                                              to: `${_unref(fetchNavigationUrl)}${_unref(validateInternalParameter)(
                              props.row.data.p1x1['taxonomy_' + _unref(taxonomy)]
                            )}${tabModel.value === 0 ? '' : '?tab=tabular'}`
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(props.row.data.p1x1["taxonomy_" + _unref(taxonomy)]), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["to"])
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(props.row.data.p1x1["taxonomy_" + _unref(taxonomy)]), 1))
                                    ]),
                                    _: 1
                                  }, 8, ["field", "label"]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columnSkeleton), (col, i) => {
                                    return (_openBlock(), _createBlock(_component_o_table_column, {
                                      key: i,
                                      label: 
                          col.convert
                            ? col.level === 1
                              ? `${col.label} ${_unref(bottomName)}`
                              : `${col.label} ${_unref(topName)}`
                            : col.label
                        ,
                                      sortable: true,
                                      visible: 
                          _unref(isColumnVisible)(col.field) &&
                          _unref(isColumnAvailable)(`first.${col.field}`)
                        ,
                                      position: "centered",
                                      class: "o-table__td--centered"
                                    }, {
                                      default: _withCtx((props) => [
                                        _createVNode(_component_performance_field, {
                                          current: 
                            col.convert
                              ? col.level === 1
                                ? props.row.data.p1x1[col.field]
                                : props.row.data.p1x2[col.field]
                              : props.row.data.p1x1[col.field]
                          ,
                                          previous: 
                            _unref(get)(
                              col.convert
                                ? col.level === 1
                                  ? props.row.data.p2x1[col.field]
                                  : props.row.data.p2x2[col.field]
                                : props.row.data.p1x1[col.field],
                              col.field
                            )
                          ,
                                          monetary: col.monetary,
                                          rounded: col.rounded,
                                          percentage: col.percentage,
                                          "one-decimal": col.oneDecimal,
                                          opposite: col.opposite,
                                          comparing: comparing.value
                                        }, null, 8, ["current", "previous", "monetary", "rounded", "percentage", "one-decimal", "opposite", "comparing"])
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "visible"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, [
                                (_unref(data))
                                  ? {
                                      name: "footer",
                                      fn: _withCtx(() => [
                                        _hoisted_48,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(footerSkeleton), (foot, i) => {
                                          return (_openBlock(), _createElementBlock("th", {
                                            class: _normalizeClass(["is-hidden-mobile text-center", {
                            'hide-cell':
                              !_unref(isColumnVisible)(foot.field) &&
                              _unref(isColumnAvailable)(`first.${foot.field}`),
                          }]),
                                            key: i
                                          }, [
                                            (foot.convert)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_unref(calculateTotalsMetaTable)(
                                _unref(metaTabularExportedData),
                                `${foot.field}_${_unref(convertNameToHandle)(
                                  foot.asset === "bottomName"
                                    ? _unref(bottomName)
                                    : _unref(topName)
                                )}`,
                                findAverageKey(
                                  `${foot.field}_${_unref(convertNameToHandle)(
                                    foot.asset === "bottomName"
                                      ? _unref(bottomName)
                                      : _unref(topName)
                                  )}`
                                )
                              )), 1))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_unref(calculateTotalsMetaTable)(
                                _unref(metaTabularExportedData),
                                foot.field,
                                findAverageKey(foot.field)
                              )), 1))
                                          ], 2))
                                        }), 128))
                                      ])
                                    }
                                  : undefined
                              ]), 1032, ["data", "default-sort-direction", "default-sort", "onSort"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})